import BaseAPI from '../base'

function loginAsWaiter(qId, pin, captcha) {
    return BaseAPI.sendPost(`auth/login/waiter`, {
        qId,
        pin,
        captcha
    });
}

function loginShared(qId) {
    return BaseAPI.sendPost('auth/login/shared', {
        qId
    })
}

function loginSharedWaiter(pin) {
    return BaseAPI.sendPost('auth/login/sharedWaiter', {
        pin
    });
}

function switchSession(sid) {
    return BaseAPI.sendPost('auth/switch', {
        sid
    });
}

function whoami() {
    return BaseAPI.sendGet(`auth/me`);
}

function logout() {
    return BaseAPI.sendPost(`auth/logout`);
}

export default {
    loginAsWaiter,
    whoami,
    loginShared,
    loginSharedWaiter,
    switchSession,
    logout
}